module.exports = __webpack_public_path__ + "static/media/web-3.e38991f5.jpg";